import React from 'react';
import clsx from 'clsx';

/**
 * PageHeader — consistent top-of-page heading block.
 *
 * <PageHeader
 *   eyebrow="קהילה"
 *   title="תל אביב צפון"
 *   description="124 חברים · 8 עדכונים היום"
 *   actions={<Button>הצטרף</Button>}
 *   meta={<Badge>פעיל</Badge>}
 * />
 */
export function PageHeader({
    eyebrow,
    title,
    description,
    actions,
    meta,
    className,
    align = 'start',     // 'start' | 'center'
    children,
    size = 'lg',         // 'sm' | 'md' | 'lg'
}) {
    const titleClass = {
        sm: 'heading-lg',
        md: 'heading-xl',
        lg: 'display-2',
    }[size] || 'heading-xl';

    return (
        <header className={clsx('w-full', className)}>
            <div className={clsx(
                'flex flex-col gap-4 sm:flex-row sm:items-end sm:justify-between',
                align === 'center' && 'items-center text-center sm:flex-col sm:items-center',
            )}>
                <div className={clsx('min-w-0 space-y-2', align === 'center' && 'mx-auto')}>
                    {eyebrow && <p className="eyebrow">{eyebrow}</p>}
                    <div className="flex flex-wrap items-center gap-3">
                        <h1 className={clsx(titleClass, 'min-w-0')}>{title}</h1>
                        {meta}
                    </div>
                    {description && (
                        <p className="text-lead text-ink-muted max-w-prose-rtl">{description}</p>
                    )}
                </div>
                {actions && (
                    <div className={clsx('flex items-center gap-2 shrink-0', align === 'center' && 'justify-center')}>
                        {actions}
                    </div>
                )}
            </div>
            {children && <div className="mt-6">{children}</div>}
        </header>
    );
}

export default PageHeader;
